import { Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

const LoaderButton = ({
  loading,
  buttonText,
  onClick,
  disabled,
  showLoader,
  className,
}) => {
  return (
    <Button
      className={className}
      disabled={disabled || loading}
      size="small"
      variant="contained"
      onClick={onClick}
    >
      {showLoader && <CircularProgress color="primary" size={20} />}

      {buttonText}
    </Button>
  );
};

export default LoaderButton;
